export const ACCION_PARTICIPAR = 2;

export const ACCION_DESCARTAR = 3;
